import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';
import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';

interface UseBulkDeleteFactsParams {
  factIds: string[];
}

export const useBulkDeleteFacts = (matterId: string, subsetId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ factIds }: UseBulkDeleteFactsParams) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.DELETE,
        data: { factIds },
      });

      const response = await fetch(`${APIBaseChronos}/api/matter/${matterId}/fact/bulk-delete/${subsetId}`, fetchConfig);

      if (!response.ok) {
        throw new Error('Failed to archive facts ');
      }

      return response;
    },
    {
      onSuccess: (_) => {
        // Invalidate relevant queries to refresh the data
        queryClient.invalidateQueries({ queryKey: [QueryEntity.SubsetFacts] });
        trackCustomEvent(TrackingEventsV2.BulkDeleteFacts);

        toast.success('Successfully archived facts');
      },
      onError: (error) => {
        console.error('Bulk delete facts error:', error);
        toast.error('Failed to archive facts');
      },
    },
  );
};
